import { Component, OnInit, Input, OnDestroy} from '@angular/core';
import { StatusbarComponent } from '../../menu/statusbar/statusbar.component';
import { TextdisplayComponent } from '../../../helpers/textdisplay/textdisplay.component';
import { MenuService } from '../../../../services/menu.service';
import { DataIoService } from '../../../../services/data-io.service';
import { ConfigService } from '../../../../services/config.service';
import { TranslationService } from '../../../../services/translation.service';
import { Helper, MenuNode,BaseSensor } from '../../../../classes';
import { ValueChangedConfirmation } from '../../../../classes/ValueChangedConfirmation';
@Component({
	selector: 'screen-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
	@Input('debug') debug:boolean=false;
	_unit:string="STD_UNIT_CELSIUS_NORMAL_LEFT";
	_value:string="22.0";
	dashIcon:string="";
	get unit(){
		if(this.noHeatingDemand()){
			return '';
		}
		if(this.sensor){
			return this.sensor.getUnit();
		}
		return this._unit;
	}
	set unit(value:string){
		this._unit = value;
	}
	constructor(
		private menuService: MenuService, 
		private ioService: DataIoService, 
		private config: ConfigService,
		private translator: TranslationService
		) { 
	}
	sensor:BaseSensor;
	eventSubscription: any;

	mode="default";

	getMode():string{
		let di = this.ioService.deviceInfo();
		for(let hc of di.getHeatingCircuits() ){
			if(hc.getScale('estrichtTrocknungsTag').getCurrentValue()> 0){
				return 'estrichtrocknung';
			}
		}

		if(this.ioService.deviceInfo().getDefaultZone().getRawValue('heatingmode')=="ENUM_HEATING_MODE_OFF"){
			return 'heating_off';
		}
		let defaultZoneId = this.ioService.deviceInfo().getDefaultZoneId();
		let defaultZone = this.ioService.deviceInfo().getZoneById(defaultZoneId);
		if(defaultZone.isAbsentAt(this.ioService.getCurrentTime())){
			return 'absent';
		}
		if(defaultZone.isCoolingAt(this.ioService.getCurrentTime())){
			return 'cooling';
		}
		if(defaultZone.getRawValue('quickset-temperature-enabled')=='on'){
			return 'quickset-temperature';
		}

		this.menuService.resetMenuPositions();
		if(this.ioService.deviceInfo().isInBlockingMode()){
			let states = this.ioService.deviceInfo().getBlockingStates();

			if(states.length > 0){
				this.mode = states[0];
				return this.mode;
			}
		}


		return 'default';

	}
	disableSlider(){
		this.menuService.disableButton('up');
		this.menuService.disableButton('down');
		this.menuService.disableButton('slider');
	}
	text : Array<string>;
	ngOnInit() {

		switch(this.getMode()){
			case 'cylinder_boost':{
				this.text = new Array<string>();
				for(let snip of [ 'HOME_CYLINDER_BOOST_SUBLINE_1', 'HOME_CYLINDER_BOOST_SUBLINE_2','HOME_CYLINDER_BOOST_SUBLINE_3' ]){
					this.text.push(this.translator.tr(snip));
				}
				this.disableSlider();
				this.dashIcon="iconDomesticWater";
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event)=>{this.eventHandler(event);}
					);
				break;
			}
			case 'ventilation_boost':{
				this.text = new Array<string>();
				for(let snip of [ 'HOME_VENTILATION_BOOST_SUBLINE_1','HOME_VENTILATION_BOOST_SUBLINE_2','HOME_VENTILATION_BOOST_SUBLINE_3']){
					this.text.push(this.translator.tr(snip));
				}
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event)=>{this.eventHandler(event);}
					);
				this.disableSlider();
				this.dashIcon="iconVentilationBoost";
				return;
			}
			case 'system_off':{
				this.text = new Array<string>();
				this.menuService.disableButton('question');
				this.menuService.disableButton('menu');
				for(let snip of [ 'SPLASH_SYSTEM_OFF_SUBLINE_1', 'HOME_SYSTEMOFF_SUBLINE_2','HOME_SYSTEMOFF_SUBLINE_3' ]){
					this.text.push(this.translator.tr(snip));
				}
				this.disableSlider();
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event)=>{this.eventHandler(event);}
					);
				this.dashIcon="iconOff2";
				return;
			}
			case 'estrichtrocknung':{
				this.mode='estrichtrocknung';
				let di = this.ioService.deviceInfo();
				for(let hc of di.getHeatingCircuits()){
					if(hc.getScale('estrichtTrocknungsTag').getCurrentValue()> 0){
						let tag = hc.getScale('estrichtTrocknungsTag').getCurrentValue();
						this.sensor = di.getScale('estrichttrocknung-tag-'+tag);
						this.text = new Array<string>();
						this.text.push(this.translator.tr('DELIGHT_SCREED_DRYING_DASHBOARD_LINE_1'));
						this.text.push(this.translator.tr('DELIGHT_SCREED_DRYING_DASHBOARD_LINE_2')+tag);
						this.text.push(this.translator.tr('DELIGHT_SCREED_DRYING_DASHBOARD_LINE_3'));
					}
				}
				this.disableSlider();
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event)=>{this.eventHandler(event);}
					);
				return;
			}

			case 'quickset-temperature':{
				this.debugOut("configuring for quickset-temperature");
				this.mode = 'quickset-temperature';
				let zone = this.ioService.deviceInfo().getDefaultZone();
				this.text = new Array<string>();
				this.text.push(this.translator.tr('EDITOR_QUICK_VETO_TEMPERATURE'));
				let endDate = zone.getDate('quickset-end-date');
				let endDateString = Helper.formatTime(endDate);
				this.disableSlider();
				let secondLine = (this.translator.tr('HOME_QUICK_VETO_SUBLINE_1')).replace("<joker>",endDateString);
				this.text.push(secondLine);
				this.text.push(this.translator.tr('HOME_QUICK_VETO_SUBLINE_2'));
				this.sensor = zone.getSensor('temperature','room_temperature_nominal_quick');
				this.dashIcon='';
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event)=>{this.eventHandler(event);}
					);

				return;
			}
			case 'heating_off':{
				this.disableSlider();
				this.mode = 'heating_off';
				this.text = new Array<string>();
				this.text.push(this.translator.tr('HOME_HEATING_OFF_SUBLINE_1'));
				let secondLine = this.translator.tr('HOME_HEATING_SUBLINE_2')+" ";
				secondLine+=this.ioService.deviceInfo().getDefaultZone().getSensor('temperature','room_temperature').toString();
				this.text.push(secondLine);
				this.dashIcon=('iconHeatingDis');
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event)=>{this.eventHandler(event);}
					);

				return;
			}
			case 'absent':{
				this.disableSlider();
				this.menuService.disableButton('question');
				this.menuService.disableButton('menu');
				this.mode = 'absent';
				this.text = new Array<string>();
				this.dashIcon = 'iconAway';
				this.text.push(this.translator.tr('HOME_HOLIDAY_SUBLINE_1'));

				let absenceEnd = this.ioService.deviceInfo().getDefaultZone().getDate('absenceEnd');
				let endString = "";
				endString += Helper.twoDigits(absenceEnd.getDate())+"."+Helper.twoDigits(absenceEnd.getMonth()+1)+"."+Helper.twoDigits(absenceEnd.getFullYear()-2000);
				endString += " / "+Helper.formatTime(absenceEnd);
				this.text.push(endString);
				this.text.push(this.translator.tr('HOME_HOLIDAY_SUBLINE_3'));
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event)=>{this.eventHandler(event);}
					);
				return;
			}
			case 'cooling':{
				this.disableSlider();
				//this.menuService.disableButton('question');
				//this.menuService.disableButton('menu');
				this.mode = 'cooling';
				this.text = new Array<string>();
				this.dashIcon = 'iconCooling';
				this.text.push(this.translator.tr('HOME_MANUAL_COOLING_SUBLINE_1'));

				let absenceEnd = this.ioService.deviceInfo().getDefaultZone().getDate('cooling_days_end');
				let endString = "";
				endString += Helper.twoDigits(absenceEnd.getDate())+"."+Helper.twoDigits(absenceEnd.getMonth()+1)+"."+Helper.twoDigits(absenceEnd.getFullYear()-2000);
				
				this.text.push(endString);
				this.text.push(this.translator.tr('HOME_MANUAL_COOLING_SUBLINE_3'));
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event)=>{this.eventHandler(event);}
					);
				return;
			}
			default:{
				this.mode="default";

				this.sensor=this.ioService.getCurrentNominalTemperatureSensor();
				if(this.noHeatingDemand()){
					this.dashIcon = 'iconInformation';
					this.text = new Array<string>();
					this.text.push(this.translator.tr('HOME_HEATING_NO_DEMAND_SUBLINE_1'));
				}
				this.debugOut("OnInit");
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event)=>{this.eventHandler(event);}
					);
				this.menuService.resetMenuPositions();
			}	
		}

	}
	noHeatingDemand(){
		return ((this.sensor == null || this.sensor == undefined) && this.mode == "default");
	}
	getText(idx:number):string{
		switch(this.mode){
			case 'heating_off':
			case 'absent':
			case 'cooling':
			case 'system_off':
			case 'ventilation_boost':
			case 'cylinder_boost':
			case 'quickset-temperature':
			case 'estrichtrocknung':{
				if(this.text && this.text.length > idx){
					return this.text[idx];
				}else{
					return "";
				}
			}
			default:{
				if(this.noHeatingDemand()&&idx == 0){
					return this.text[0];
				}
				return this.menuService.getCurrentNode().getText(idx);
			}
		}
	}

	get value(){
		if(this.sensor){
			return this.sensor.getCurrentValue().toFixed(1);
		}else{
			return '';
		}
	}
	ngOnDestroy(){
		this.debugOut("onDestroy");
		if(this.eventSubscription){
			this.eventSubscription.unsubscribe();
		}
	}	

	debugOut(msg:string):void{
		if(this.debug){
			console.log("DashboardComponent: "+msg);
		}
	}
	eventHandler(event){
		this.debugOut("Handling Event: "+event);
		switch(event){
			case 'down':
			case 'panup':
			case 'pandown':
			case 'up':{
				let heatingMode = this.ioService.deviceInfo().getDefaultZone().getRawValue('heatingmode');
				switch(heatingMode){
					case 'ENUM_HEATING_MODE_OFF':{
						return;
					}
					case 'ENUM_HEATING_MODE_MANUAL':{
						this.menuService.goto('desired-temperature');
						return;
					}
					case 'ENUM_HEATING_MODE_TIMECONTROLLED':{
						this.menuService.goto('quickset-desired-temperature');
						return;	
					}
					
				}
				
				break;
			}
			case 'confirm':{
				break;
			}
			case 'menu':{

				if(this.ioService.deviceInfo().getValue('system_off') == 'off'){
					this.menuService.goto('mainmenu');
				}
				break;
			}
			case 'back':{
				let backTarget = 'dashboard';
				let retVal : ValueChangedConfirmation = undefined;
				switch(this.mode){

					case 'system_off':
					case 'ventilation_boost':
					case 'cylinder_boost':{
						let confirmation = new ValueChangedConfirmation(this.mode,'on','off',new MenuNode({'target':'goto:'+backTarget}));
						this.ioService.deviceInfo().setValue(this.mode,'off');
						this.menuService.goto(backTarget,confirmation);
						return;
					}
					case 'quickset-temperature':{
						let zone = this.ioService.deviceInfo().getDefaultZone();
						zone.getScale('quickset-temperature-duration').setCurrentValue(3,true);
						zone.setValue('quickset-temperature-enabled','off');
						retVal = new ValueChangedConfirmation('quickset-temperature-enabled','on','off',new MenuNode({'target':'goto:'+backTarget}));
						this.menuService.goto(backTarget,retVal);
						return;
					}
					case 'estrichtrocknung':{
						let oldVal = -1;
						for(let hc of this.ioService.deviceInfo().getHeatingCircuits()){
							oldVal=hc.getScale('estrichtTrocknungsTag').getCurrentValue();
							hc.getScale('estrichtTrocknungsTag').setCurrentValue(0);

						}

						retVal = new ValueChangedConfirmation('estrichtTrocknungsTag','on','off',new MenuNode({'target':'goto:'+backTarget}));
						this.menuService.goto(backTarget,retVal);
						return;

					}
					case 'cooling':{
						let zone = this.ioService.deviceInfo().getDefaultZone();
						let startDate = zone.getDate('cooling_days_begin');
						zone.setDate('cooling_days_end',startDate);
						retVal = new ValueChangedConfirmation('cooling_days_end','on','off',new MenuNode({'target':'goto:'+backTarget}));
						this.menuService.goto(backTarget,retVal);
						return;
					}
					case 'absent':{
						let zone = this.ioService.deviceInfo().getDefaultZone();
						let startDate = zone.getDate('absenceBegin');
						zone.setDate('absenceEnd',startDate);
						retVal = new ValueChangedConfirmation('absenceEnd','on','off',new MenuNode({'target':'goto:'+backTarget}));
						this.menuService.goto(backTarget,retVal);
						return;
					}
					default:{
						this.menuService.goto('idle');
					}
				}
				
				break;
			}
			case 'question':{
				if(!['absent','system_off'].includes(this.mode)){
					let benutzerHandbuch = this.menuService.findItem('benutzerhandbuch_plain');
					if(benutzerHandbuch){
						this.menuService.goto(benutzerHandbuch);
					}
					return;
				}else{
					this.debugOut("Doing nothing: mode is " + this.mode);
				}
			}
			default:{

			}
		}
	}

}
